import React from 'react';
import { MessageCircle, Phone, Mail, MapPin } from 'lucide-react';
import { CONTACT } from './Constants';
export function ContactSection() {
  return <section id="contacto" className="py-16 md:py-24 bg-white" data-id="element-37">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-38">
        <div className="bg-graySoft rounded-3xl p-8 md:p-12 shadow-sm border border-gray-100" data-id="element-39">
          <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-40">
            <h2 className="text-3xl md:text-4xl font-bold text-azul mb-6" data-id="element-41">
              ¿Necesitas orientación para ti o para un familiar?
            </h2>
            <p className="text-lg text-gray-600" data-id="element-42">
              Puedes comunicarte directamente con Evolución Chile. Te
              orientaremos de forma confidencial para ayudarte a entender el
              siguiente paso.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-43">
            {/* Action Buttons */}
            <div className="flex flex-col gap-4" data-id="element-44">
              <a href={CONTACT.whatsappUrl} target="_blank" rel="noopener noreferrer" className="w-full flex items-center justify-center px-8 py-4 border border-transparent rounded-xl shadow-sm text-lg font-semibold text-white bg-whatsapp hover:bg-whatsapp-hover transition-colors" data-id="element-45">
                <MessageCircle className="w-6 h-6 mr-3" data-id="element-46" />
                Hablar por WhatsApp
              </a>
              <a href={CONTACT.phoneUrl} className="w-full flex items-center justify-center px-8 py-4 border-2 border-azul rounded-xl text-lg font-semibold text-azul hover:bg-azul hover:text-white transition-colors" data-id="element-47">
                <Phone className="w-6 h-6 mr-3" data-id="element-48" />
                Llamar ahora
              </a>
            </div>

            {/* Contact Details */}
            <div className="space-y-6 bg-white p-8 rounded-2xl border border-gray-100" data-id="element-49">
              <div className="flex items-start" data-id="element-50">
                <MessageCircle className="w-6 h-6 text-celeste mr-4 flex-shrink-0" data-id="element-51" />
                <div data-id="element-52">
                  <p className="text-sm text-gray-500 font-medium" data-id="element-53">WhatsApp</p>
                  <p className="text-lg font-semibold text-gray-900" data-id="element-54">
                    {CONTACT.whatsappDisplay}
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-55">
                <Phone className="w-6 h-6 text-celeste mr-4 flex-shrink-0" data-id="element-56" />
                <div data-id="element-57">
                  <p className="text-sm text-gray-500 font-medium" data-id="element-58">Llamadas</p>
                  <p className="text-lg font-semibold text-gray-900" data-id="element-59">
                    {CONTACT.phoneDisplay}
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-60">
                <Mail className="w-6 h-6 text-celeste mr-4 flex-shrink-0" data-id="element-61" />
                <div data-id="element-62">
                  <p className="text-sm text-gray-500 font-medium" data-id="element-63">Email</p>
                  <p className="text-base font-medium text-gray-900 break-all" data-id="element-64">
                    {CONTACT.email}
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-65">
                <MapPin className="w-6 h-6 text-celeste mr-4 flex-shrink-0" data-id="element-66" />
                <div data-id="element-67">
                  <p className="text-sm text-gray-500 font-medium" data-id="element-68">
                    Dirección principal
                  </p>
                  <p className="text-base font-medium text-gray-900" data-id="element-69">
                    {CONTACT.address}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}